/*
 * @Descripttion:问卷详情
 * @Date: 2025-04-10 10:12:42
 */
import { ProjectType } from '../../types';
import QuestionDetail5_20_21 from './question-detail-5_20_21.vue'; //调研问卷（表单）可配置（表单+目标题+风控题） 数字问卷（专区+资讯+表单）
import QuestionDetai19 from './question-detail-19.vue'; //协定服务（固定字段+特殊计价）
import QuestionDetai17 from './question-detail-17.vue'; //数字拜访（专区+资讯+目标题+固定字段）

export const questionDetailComps = (projectType: ProjectType) => {
  const compMap = {
    20: QuestionDetail5_20_21,
    5: QuestionDetail5_20_21,
    19: QuestionDetai19,
    17: QuestionDetai17,
    21: QuestionDetail5_20_21
  };
  return compMap[projectType];
};
